const images = {
    LOGO: require('./Agilearn-logo.png')
  }
  
  export default images
  
